var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container calendar-list-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择闭馆维修时间"
              },
              model: {
                value: _vm.listQuery.week,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "week", $$v)
                },
                expression: "listQuery.week"
              }
            },
            _vm._l(_vm.statusOptions, function(item) {
              return _c("el-option", {
                key: item.dicValue,
                attrs: { label: item.dicName, value: item.dicValue }
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择区域"
              },
              model: {
                value: _vm.listQuery.areaId,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "areaId", $$v)
                },
                expression: "listQuery.areaId"
              }
            },
            _vm._l(_vm.companyList, function(item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.areaName, value: item.id }
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择场地名称"
              },
              model: {
                value: _vm.listQuery.placeId,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "placeId", $$v)
                },
                expression: "listQuery.placeId"
              }
            },
            _vm._l(_vm.placeOptions, function(item) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.areaName + item.placeName, value: item.id }
              })
            }),
            1
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v(_vm._s(_vm.$t("button.search")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-circle-plus-outline" },
              on: { click: _vm.handleCreate }
            },
            [_vm._v(_vm._s(_vm.$t("button.add")))]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { icon: "el-icon-delete", type: "danger" },
              on: { click: _vm.handleDeletes }
            },
            [_vm._v(_vm._s(_vm.$t("button.delete")))]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "55" } }),
          _c("el-table-column", {
            attrs: { type: "index", label: _vm.$t("table.id"), width: "50" }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "区域名称",
              "show-overflow-tooltip": "",
              "min-width": "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.areaName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "场地名称",
              "show-overflow-tooltip": "",
              "min-width": "200"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.placeName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "时间段",
              "min-width": "300px",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.periodName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "闭馆维修开始日期",
              "min-width": "140px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.startTime))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "闭馆维修结束日期",
              "min-width": "140px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.endTime))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "订场时间", "min-width": "120px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.weekName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "备注", "min-width": "120px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.remark))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.actions"),
              "class-name": "small-padding fixed-width",
              "min-width": "200px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          size: "mini",
                          plain: "",
                          icon: "el-icon-edit"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleUpdate(scope.row.id)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.edit")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "danger",
                          size: "mini",
                          plain: "",
                          icon: "el-icon-delete"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleDelete(scope.row.id)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("button.delete")))]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listQuery.page,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _vm.listQuery.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "900px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("add", {
            attrs: {
              "key-value": _vm.Id,
              "show-dialog": _vm.dialogFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }